import { render, staticRenderFns } from "./RouteTask.vue?vue&type=template&id=132f004e&scoped=true"
import script from "./RouteTask.vue?vue&type=script&lang=js"
export * from "./RouteTask.vue?vue&type=script&lang=js"
import style0 from "./RouteTask.vue?vue&type=style&index=0&id=132f004e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f004e",
  null
  
)

export default component.exports